<template>
  <div class="app-footer">
    <div class="app-footer__logo">
      <UkaskoLogo />
    </div>
    <div class="app-footer__sections">
      <div class="app-footer__section">
        <h4 class="app-footer__title">Контакти</h4>
        <ul class="app-footer__list">
          <li
            v-for="(item, index) in getLinks('promo', 'footer-contacts')"
            :key="index"
            class="app-footer__item"
          >
            <SmartLink
              class="app-footer__text app-footer__link"
              :url="item.url"
              :target="item.target"
              v-html="formatBasicText(item.title)"
            >
            </SmartLink>
          </li>
          <li class="app-footer__item">
            <p class="app-footer__text">{{ getKeyValueListBlockValue('promo', 'footer-contacts-list', 'location') }}</p>
          </li>
          <li class="app-footer__item">
            <p class="app-footer__text">{{ getKeyValueListBlockValue('promo', 'footer-contacts-list', 'working-hours') }}</p>
          </li>
        </ul>
      </div>
      <div class="app-footer__section">
        <h4 class="app-footer__title">Слідкуй за нами</h4>
        <ul class="app-footer__list">
          <li
            v-for="(item, index) in getLinks('promo', 'footer-social-links')"
            :key="index"
            class="app-footer__item"
          >
            <SmartLink
              class="app-footer__text app-footer__link"
              :url="item.url"
              :target="item.target"
              v-html="formatBasicText(item.title)"
            >
            </SmartLink>
          </li>
        </ul>
      </div>
      <div class="app-footer__section">
        <h4 class="app-footer__title">Корисні посилання</h4>
        <ul class="app-footer__list">
          <li
            v-for="(item, index) in getLinks('promo', 'footer-links')"
            :key="index"
            class="app-footer__item"
          >
            <SmartLink
              class="app-footer__text app-footer__link"
              :url="item.url"
              :target="item.target"
              v-html="formatBasicText(item.title)"
            >
            </SmartLink>
          </li>
        </ul>
      </div>
      <div class="app-footer__button-group">
        <OrangeFancyButton :route="{ name: 'promo' }" hash="#subscribe" class="button-link">
          Записатись на демо
        </OrangeFancyButton>
        <VioletFancyButton :route="{ name: 'registration' }" class="button-link">
          Реєстрація
        </VioletFancyButton>
        <p class="app-footer__copyright">© {{ moment().format('YYYY') }} UConnect. Всі права захищено.</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { textBlock } from '@/entities/text-block';
import { basicFormatter } from '@/shared/lib/string';
import { OrangeFancyButton, VioletFancyButton } from '@/shared/ui/form';
import { UkaskoLogo } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';

export default {
  mixins: [ textBlock, basicFormatter ],
  components: { UkaskoLogo, SmartLink, OrangeFancyButton, VioletFancyButton },
  methods: {
    moment,
    getLinks(page, block) {
      const textBlock = this.getListBlock(page, block);
      return textBlock.map((item) => {
        return {
          title: item.text,
          url: item.url,
          target: item.target,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: #313437;
  padding: 55px;
  overflow: hidden;

  @media (max-width: 1050px) {
    padding: 0 32px 32px;
  }

  &__logo {
    margin-bottom: 45px;
  }

  &__sections {
    display: flex;
    justify-content: space-between;
    gap: 32px;

    @media (max-width: 1050px) {
      flex-direction: row;
      flex-wrap: wrap;
      row-gap: 0;
    }

    @media (max-width: 600px) {
      flex-direction: column;
    }

    & > div {
      @media (max-width: 1050px) {
        width: calc(50% - 16px);
      }

      @media (max-width: 600px) {
        width: 100%;
      }
    }
  }

  &__section {
    flex: 0 1 260px;
    min-width: 0;
    max-width: 260px;

    @media (max-width: 1050px) {
      flex: none;
      max-width: none;
      margin-bottom: 16px;
    }
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 22px;
    font-weight: 600;
    color: #FFFFFF;
    margin-bottom: 24px;
  }

  &__text, &__link {
    position: relative;
    display: inline-block;
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #CADDFC;
    margin-bottom: 16px;
    max-width: 100%;
    overflow-wrap: break-word;
  }

  &__link {
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      width: 0;
      background-color: #EB883B;
      transition: width 1s ease;
    }

    &:hover {
      color: #EB883B;

      &::after {
        width: 100%;
      }
    }

    ::v-deep p {
      margin: 0 !important;
    }
  }

  &__button-group {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 0 0 25%;
    width: 25%;

    @media (max-width: 1050px) {
      flex: none;
      width: 100%;
    }

    .button-link {
      @media (max-width: 1050px) {
        margin-bottom: 16px;
      }
    }
  }

  &__copyright {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #CADDFC;
    text-align: right;

    @media (max-width: 1050px) {
      margin-top: 16px;
    }
  }
}
</style>
